<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="网络服务交易合同"
    width="70%"
    custom-class="myWindow"
  >
    <div class="contract-info" v-html="contractInfo.contract_text">
      
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="send">发给用户</el-button>
      <el-button @click="visible = false">取 消</el-button>
    </span>

  </el-dialog>
</template>

<script>
//import { contractShow,contractUpdate} from "@/api/director/work/recruit/index";

export default {

  data() {
    return {
      visible: false,
      formData: {
        enroll_id:[],
        contract_type:1,
        relation_status:"12",
      },
      contractInfo:{
        id: "",
        contract_name: "",
        contract_text: "",
        contract_mark: "",
        contract_file: "",
        contract_fname: "",
        status: 1,
       
      }
    
    };
  },

 
  mounted() {

  },
  
  methods: {
    handleClose() {
      this.visible = false;

    },


    init(enroll_id) {//enroll_id
      this.visible = true;
      this.formData.enroll_id=[enroll_id];

      contractShow({}).then((response) => {
          if(response.code==200){
            this.contractInfo=response.data;
          }
      });
    },


    
    
    send(){
      var that=this;
      contractUpdate(that.formData).then((response) => {
        console.log(response);
        if(response.code==200){
          this.$message({
              message: "提交成功",
              type: 'success'
          });
          that.$emit('refresh');
          that.visible = false;
        
        }else{
          this.$message({
            message: response.msg?response.msg:"提交失败",
          });
        }
      });
    },

  },

 
};
</script>

<style lang="scss" scoped>
.contract-info{
  height: 75vh ;
  overflow-y: auto;
}

::v-deep .el-dialog__body {
    height: 75vh ;
    //overflow: hidden;
   // overflow-y: auto;
   padding: 0px 25px;
  }



  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
 
::v-deep .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}
</style>
